import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="w-full bg-white">
      <section className="py-16">
        <div className="layout-container max-w-[800px] mx-auto px-5">
          <nav className="mb-6 text-[12px] font-description text-[#919191]">
            <Link to="/" className="hover:text-[#212121] transition-colors">
              Homepage
            </Link>
            <span className="mx-2">/</span>
            <span className="text-[#212121]">Privacy Policy</span>
          </nav>

          <h1 className="font-title text-[36px] md:text-[46px] font-semibold leading-[1.1] text-[#212121]">
            Privacy Policy
          </h1>
          
          <div className="mt-8 space-y-6 font-description text-[14px] font-light leading-[1.6] text-[#919191]">
            <p><strong>Effective Date:</strong> August 5, {new Date().getFullYear()}</p>
            <p><strong>Company:</strong> Bao Technologies (Bao Technologies and Travels SARL)</p>
            <p><strong>Location:</strong> Douala, Cameroon</p>
            <p><strong>Website:</strong> <a href="https://baotechnologies.com" className="text-[#2776EA] hover:underline">https://baotechnologies.com</a></p>
            
            <h2 className="font-title text-[20px] font-medium text-[#212121] mt-10 mb-4">Overview</h2>
            <p>
              Bao Technologies respects your privacy and is committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, use our digital solutions, or interact with our services.
            </p>

            <h2 className="font-title text-[20px] font-medium text-[#212121] mt-10 mb-4">Information We Collect</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Personal Identification Information:</strong> Name, email address, phone number, and company name when submitted via our contact forms or consultation requests.</li>
              <li><strong>Technical Data:</strong> IP address, browser type, device information, and browsing behaviour collected automatically via cookies and analytics tools.</li>
              <li><strong>Project &amp; Business Information:</strong> Details shared during custom software consultations, project scoping, or contract discussions.</li>
            </ul>

            <h2 className="font-title text-[20px] font-medium text-[#212121] mt-10 mb-4">How We Use Your Information</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li>To respond to inquiries, consultation requests, and project proposals.</li>
              <li>To deliver, maintain, and improve our website, platforms, and services.</li>
              <li>To communicate updates, administrative notices, and relevant service information.</li>
              <li>To comply with applicable Cameroonian data protection regulations and legal obligations.</li>
            </ul>

            <h2 className="font-title text-[20px] font-medium text-[#212121] mt-10 mb-4">Data Security &amp; Retention</h2>
            <p>
              We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. Data is retained only as long as necessary to fulfill the purposes outlined in this policy or as required by law.
            </p>

            <h2 className="font-title text-[20px] font-medium text-[#212121] mt-10 mb-4">Your Rights</h2>
            <p>
              You have the right to request access to, correction of, or deletion of your personal data held by us. To make a request, contact us at <a href="mailto:contact@baotechnologies.com" className="text-[#2776EA] hover:underline">contact@baotechnologies.com</a>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
